module.exports = __webpack_public_path__ + "static/media/GradientCovariance.da1d782b.ipynb";